"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var _util_1 = require("../../_util");
function BannerBtnItem(props) {
    var _a = props || {}, filedVideoList = _a.filedVideoList, filedVideoBg = _a.filedVideoBg, postMessageUrl = _a.postMessageUrl, iconUrl = _a.iconUrl, extendProps = _a.extendProps, href = _a.href, label = _a.label, liveType = _a.liveType, onCallback = _a.onCallback, _b = _a.isWhiteBtn, isWhiteBtn = _b === void 0 ? false : _b;
    var _c = (0, _util_1.fomateFileData)(iconUrl), formatIconUrl = _c.url, _d = _c.alt, iconAlt = _d === void 0 ? '' : _d;
    var btnClick = function () {
        if (filedVideoList) {
            (0, _util_1.reinitIframe)({
                filedVideoBg: filedVideoBg,
                filedVideoList: filedVideoList,
                postMessageUrl: postMessageUrl,
            });
            return;
        }
        if (!onCallback) {
            window.location.href = href;
            return;
        }
        onCallback === null || onCallback === void 0 ? void 0 : onCallback(props);
    };
    if (!label) {
        return null;
    }
    return (react_1.default.createElement("a", __assign({ className: (0, classnames_1.default)('not-a-style', {
            'audiovb-theme': liveType === 'audiovb',
            'student-theme': liveType === 'student',
            'lighthouse-theme': liveType === 'lightHouse',
            'freetier-theme': liveType === 'freetier',
            'is-white-theme': !!isWhiteBtn,
        }) }, (extendProps || {}), { onClick: btnClick }),
        formatIconUrl && react_1.default.createElement("img", { src: formatIconUrl, alt: iconAlt }),
        label));
}
exports.default = BannerBtnItem;
//# sourceMappingURL=BannerBtnItem.js.map